export default "__VITE_ASSET__CaCtOQWh__"